// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"261":"pharmacy-search-form","322":"preorder"}[chunkId] + ".css";
};